module.exports = __webpack_public_path__ + "img/menu_label.68a51f8b.png";